import { render } from "./chat.svg?vue&type=template&id=c2aaf4b4"
const script = {}
script.render = render

export default script